//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkBreakpoint, defaultBlockProps } from '~/helpers';

export default {
    name: 'BowFormContact',

    props: {
        ...defaultBlockProps,

        coordinates: {
            default: () => ({
                lat: null,
                lng: null,
            }),
            type: Object,
        },

        indirizzo: {
            default: null,
            type: String,
        },
    },

    data: () => ({
        baseURL: 'https://www.libertyhomes.it/',
        checkBreakpointUpXl: false,
        fields: [],
        formBaseURL: 'https://www.libertyhomes.it/cms/',
        idForm: 986,
        nonce: null,
        redirect: null,
        token: null,
    }),

    async fetch() {
        if (typeof window === 'undefined') {
            return;
        }

        if (this.$config.BASE_URL) {
            this.baseURL =
                this.$config.BASE_URL || 'https://www.libertyhomes.it/';
        }

        if (this.$config.CMS_BASE_URL) {
            this.formBaseURL =
                this.$config.CMS_BASE_URL || `${this.baseURL}cms/`;
        }

        try {
            let urlFormContattiHTML = `${this.formBaseURL}form-contatti/`;

            if (this.$store.app.i18n.locale === 'en') {
                urlFormContattiHTML = `${this.formBaseURL}en/form-contatti/`;
            }

            const formContattiHTML = await this.$axios.$get(
                urlFormContattiHTML
            );
            const domFormContatti = new DOMParser().parseFromString(
                formContattiHTML,
                'text/html'
            );

            const tokenElement =
                domFormContatti.documentElement.querySelector('form');
            if (tokenElement) {
                this.token = tokenElement.getAttribute('data-token');
            }

            const nonceElement = domFormContatti.documentElement.querySelector(
                'input[name="wpforms[nonce]"]'
            );
            if (nonceElement) {
                this.nonce = nonceElement.value;
            }

            if (this.token && this.token !== '') {
                this.idForm = 986;

                if (this.$store.app.i18n.locale === 'en') {
                    this.idForm = 3005;
                }

                const formData = await this.$axios.$get(
                    `/forms/${this.idForm}`,
                    {
                        params: {
                            culture: this.$store.app.i18n.locale,
                        },
                    }
                );

                if (formData.isSuccess === true && formData.payload) {
                    if (formData.payload.posts && formData.payload.posts[0]) {
                        const fieldsList = {
                            ...formData.payload.posts[0].wpFormInfos.fields,
                        };

                        Object.entries(fieldsList).forEach(([key, value]) => {
                            if (value.type === 'checkbox') {
                                const subfields = [];
                                Object.entries(value.choices).forEach(
                                    ([subkey, subval]) => {
                                        subfields.push({
                                            ...subval,
                                            id: subkey,
                                        });
                                    }
                                );

                                this.fields.push({
                                    ...value,
                                    subfields,
                                });
                            } else {
                                this.fields.push(value);
                            }
                        });

                        const { confirmations } =
                            formData.payload.posts[0].wpFormInfos.settings;
                        if (
                            confirmations &&
                            confirmations[1] &&
                            confirmations[1].type === 'page'
                        ) {
                            if (
                                confirmations[1].page &&
                                typeof this.$getSlugByID !== 'undefined'
                            ) {
                                const postSlug = await this.$getSlugByID(
                                    parseInt(confirmations[1].page, 10)
                                );

                                this.redirect = postSlug
                                    ? `/${postSlug}`
                                    : null;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            console.error(err);
        }
    },

    computed: {
        location() {
            if (this.coordinates.lat && this.coordinates.lng) {
                return [
                    {
                        card: {
                            customTitle: 'Liberty Homes',
                            customSubtitle: this.indirizzo,
                            coordinates: {
                                ...this.coordinates,
                            },
                        },
                    },
                ];
            }

            return [];
        },
    },

    mounted() {
        this.checkBreakpointUpXl = checkBreakpoint.up('xl');
    },

    methods: {
        async handleSubmit({ target }) {
            const formData = {};
            const formElement = target;
            const formFields = [...formElement.querySelectorAll('.form-field')];
            formFields.forEach((element) => {
                const textarea = element.querySelector('textarea');
                if (textarea) {
                    const key = textarea.getAttribute('name');
                    const value = textarea.value;
                    formData[key] = {
                        value,
                        sublist: false,
                    };

                    return;
                }

                const input = element.querySelector('input');
                if (input) {
                    const type = input.getAttribute('type');

                    if (type === 'checkbox') {
                        const key = input.getAttribute('name');

                        if (input.checked === false) {
                            formData[key] = {
                                value: '',
                                sublist: true,
                            };

                            return;
                        }

                        const label = element.querySelector('.a-input__text');
                        const value = label.innerText;

                        formData[key] = {
                            value,
                            sublist: true,
                        };

                        return;
                    }

                    const key = input.getAttribute('name');
                    const value = input.value;
                    formData[key] = {
                        value,
                        sublist: false,
                    };
                }
            });

            // const form = new FormData( target );
            // const data = Object.fromEntries(form);
            // console.log(data);

            // console.log(formData);

            try {
                const dataToSend = {
                    'wpforms[id]': `${this.idForm}`,
                    'wpforms[author]': '1',
                    'wpforms[post_id]': '1512',
                    'wpforms[submit]': 'wpforms-submit',
                    'wpforms[token]': this.token,
                    'wpforms[nonce]': this.nonce,
                    action: 'wpforms_submit',
                };

                Object.entries(formData).forEach(([key, value]) => {
                    // if ( typeof value === 'object' ) {
                    //   let subkeyDef = 0;
                    //   let subValueDef = '';
                    //   Object.entries( value ).forEach(([subkey, subvalue]) => {
                    //     subkeyDef = subkey;
                    //     subValueDef = subvalue;
                    //   });

                    //   dataToSend[`wpforms[fields][${key}][${subkeyDef}]`] = subValueDef;

                    //   return;
                    // }
                    if (value.sublist === true) {
                        dataToSend[`wpforms[fields][${key}][]`] = value.value;

                        return;
                    }

                    dataToSend[`wpforms[fields][${key}]`] = value.value;
                });
                // console.log(dataToSend);

                const fd = new FormData();
                Object.entries(dataToSend).forEach(([key, value]) => {
                    fd.append(key, value);
                });

                const postCall = await this.$axios.$post(
                    `${this.formBaseURL}wp-admin/admin-ajax.php`,
                    fd,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );

                // console.log(postCall);

                if (postCall && postCall.success === true) {
                    // alert(postCall.data.confirmation);

                    if (this.redirect) {
                        this.$router.push(this.localePath(this.redirect));
                    }
                }
            } catch (err) {
                console.error(err);
            }
        },
    },
};
